/**
 * @param cookieName
 * @param cookieValue
 */
export const saveCookie = (cookieName, cookieValue) => {
    document.cookie = `${cookieName}=${cookieValue};`;
}
